import React, { useEffect, useState } from 'react';
import { accessService } from '../../services/central-api/access';
import FilterDropdown from '../Filter/components/FilterDropdown';
import { translate } from '../../services/translate';
import { UseFormReturn } from 'react-hook-form';
import FormDropDownPicker from '../FormDropDownPicker';


type Props = {
    zIndex: number;
    actingBodyId?: number;
    label: string;
} & ({
    form?: undefined;
    fieldName?: undefined;
    customValidations?: undefined;
    pattern?: undefined;
    value: number;
    setValue: React.Dispatch<React.SetStateAction<number>>;
} | {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    form: UseFormReturn<any, any, any>;
    fieldName: string;
    value?: undefined;
    setValue?: undefined;
});

function GenericUserDropdown({ value, setValue, zIndex, actingBodyId, label, form, fieldName }: Props) {
    const [selectableUsers, setSelectableUsers] = useState<{ label: string; value: number; }[]>([]);

    async function getUsers(actingBodyId?: number) {
        try {
            const users = await accessService.getAccessAllUsers({ actingBodyId });
            setSelectableUsers([
                ...users.map((user) => {
                    return {
                        value: user.id,
                        label: user.name
                    };
                })
            ]);
        } catch (err) {
            console.error(err);
        }
    }

    useEffect(() => {
        getUsers(actingBodyId);
    }, [actingBodyId]);

    if (form && fieldName) {
        return <FormDropDownPicker
            label={translate(label)}
            items={selectableUsers}
            multiple={false}
            fieldName={fieldName}
            form={form}
            zIndex={zIndex}
        />;
    } else if (value !== undefined && setValue !== undefined) {
        return (
            <FilterDropdown
                label={translate(label)}
                items={selectableUsers}
                multiple={false}
                setValue={setValue}
                value={value}
                zIndex={zIndex}
            />
        );
    }
}

export default GenericUserDropdown;
